import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login",
  "use": "icon-login-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-login\"><path d=\"M512 329.2m-196.8 0a196.8 196.8 0 1 0 393.6 0 196.8 196.8 0 1 0-393.6 0Z\" p-id=\"71521\" /><path d=\"M652.6 610.4H371.4c-139.2 0-253.1 113.4-253.1 281.2h787.4c-0.1-152.2-113.9-281.2-253.1-281.2z\" p-id=\"71522\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol